/**
 * NumbersPanel.tsx — the `#numbers*` route's wrapper: a `TabStrip` (Number /
 * Products) plus the active tab's page. Composes once here rather than
 * duplicating the tab markup inside `NumbersPage`/`ProductsPage` — UX decision
 * (Garrett) resolving the NUM5/NUM6 route conflict: `#numbers` defaults to the
 * Number tab, `#numbers/products` selects Products.
 */

import { useTranslation } from 'react-i18next';
import type { ApiClient } from '../../api/client';
import { TabStrip } from '../../components/TabStrip';
import { ProductsPage } from '../products/ProductsPage';
import { NumbersPage } from './NumbersPage';

export interface NumbersPanelProps {
  apiClient: ApiClient;
  activeTab: 'number' | 'products';
}

export const NumbersPanel = ({ apiClient, activeTab }: NumbersPanelProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <TabStrip
        activeId={activeTab}
        items={[
          { id: 'number', label: t('numbers.title'), href: '#numbers' },
          { id: 'products', label: t('products.title'), href: '#numbers/products' },
        ]}
      />
      {activeTab === 'products' ? (
        <ProductsPage apiClient={apiClient} />
      ) : (
        <NumbersPage apiClient={apiClient} />
      )}
    </div>
  );
};
